import { ConditionalTooltip } from "components/ConditionalTooltip";
import { GlobalContext } from "contexts/GlobalContext";
import { useCallback, useContext } from "react";
import { RouteLink } from "Routes";
import { GameStateProps } from "types/GameStateProps";

export const CopyStoryLinkButton = (props: GameStateProps) => {
    const { gameState } = props;

    const { addNotification } = useContext(GlobalContext);

    const copyShareLink = useCallback(() => {
        if (gameState) {
            const selectedCode = gameState.code;
            const url = `${window.location.origin}${RouteLink.discoverHallOfFameStory(selectedCode)}`;

            // copy to clipboard
            const text = `🎮 Frankenstories ✏️
 
${gameState.title ?? gameState.gameName}

🧑 ${gameState.playerCount}  🔔 ${gameState.roundCount}  💬 ${gameState.replyCount}

${url}`;

            navigator.clipboard.writeText(text);

            // show toast
            addNotification({
                title: "Link copied",
                description: "Share it with your friends!",
                type: "success",
            });
        }
    }, [addNotification, gameState]);

    return (
        <ConditionalTooltip show={true} text="Share game">
            <button type="button" className="btn btn-dark btn-circle" onClick={copyShareLink}>
                <span className="fal fa-share"></span>
            </button>
        </ConditionalTooltip>
    );
};
